import { render, staticRenderFns } from "./line-superior.vue?vue&type=template&id=6bd5aa2a&"
import script from "./line-superior.vue?vue&type=script&lang=js&"
export * from "./line-superior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports